import React from "react";
import { AiFillCheckCircle } from "react-icons/ai";

function Right() {
    return (
        <div className="right-icon right">
            <AiFillCheckCircle />
        </div>
    );
}

export default Right;